import { render } from "./Footer.vue?vue&type=template&id=a9c3f872&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=a9c3f872&lang=css"
import "./Footer.vue?vue&type=style&index=1&id=a9c3f872&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9c3f872"]])

export default __exports__